import { Flex, Text } from "@chakra-ui/react";
import { VscFileSymlinkFile } from "react-icons/vsc";

function NoDataFound() {
  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      my={3}
    >
      <VscFileSymlinkFile size="3rem" color="gray" />
      <Text color="blackAlpha.700" py="3">
        No data
      </Text>
      <Text color="blackAlpha.700">
        No data, Please try again later
      </Text>
    </Flex>
  );
}

export default NoDataFound;
